import { ThemeSettingsType } from "./themeSettingsType";

export const THEME_SETTINGS: ThemeSettingsType = {
	defaultCountryFlag: "DE",
	defaultCurrency: "EUR",
	supportEmail: "support@tipwin.de",
	countryRegionFilterAbrv: "germany",
	isPlayerInformationCenterEnabled: true,
	welcomePopupsEnabled: true,
	isOnboardingNextPopupEnabled: false,
	isOnboardingRegisterPopupEnabled: true,
	isOnboardingNewsletterPopupEnabled: true,
	shouldShowControlAdvice: false,
	showBetQRScanner: false,
	isReceivingPromoMailEnabled: true,
	isAccountLockPromoEnabled: true,
	shouldUserSetMonthlyDepositLimit: true,
	showLiveCasinoWalletPayment: false,
	liveCasinoCategoryProviders: [],
	liveCasinoLobbyProviders: [],
	casinoProviders: [],
	enableAccountLockUpdateOnLogin: false,
	realityCheckUpdateEnabled: false,
	isDKMW: false,
	failedLoginReport: {
		isEnabled: false,
		reportMode: 1,
		queryIntervalInHours: 120,
		queryLimit: 50,
	},
	accountLockDurations: [
		"1-day",
		"7-days",
		"permanent",
		"30-days",
		"14-days",
	],
	bettingTimeoutDurations: [
		"deactivate-betting-timeout",
		"1-hour",
		"2-hours",
		"3-hours",
		"4-hours",
		"6-hours",
		"8-hours",
		"10-hours",
		"12-hours",
		"14-hours",
		"16-hours",
		"24-hours",
		"72-hours",
	],
	licensingIcons: ["ggl", "ssl", "gambling-therapy", "gamcare", "dswv"],
	isWelcomeTextEnabled: false,
	isAccountVerificationSectionEnabled: true,
	isPlayerMoneyProtectionEnabled: false,
	isWhistleblowingEnabled: false,
	isBettingRulesEnabled: false,
	isAutomaticLogoutEnabled: true,
	isSpelpausEnabled: false,
	isGamingSummaryEnabled: false,
	isPersonalNumberEnabled: false,
	isGamingHistoryReportEnabled: false,
	isHeaderIconsEnabled: false,
	is24hLockEnabled: false,
	isCreditRatingCheckEnabled: true,
	isRealityCheckEnabled: true,
	isRealityCheckWithHeaderEnabled: true,
	isLogoutPopupEnabled: true,
	isWaitingPeriodEnabled: true,
	defaultStake: 5,
	defaultAccount: "",
	isOasisEnabled: true,
	isInsicEnabled: true,
	keepAliveInterval: 600,
	showOnBoardingWelcomeBonusPopup: false,
	isGglEnabled: true,
	realityCheckInterval: 60,
	accountRecheckExpiringInterval: 10,
	welcomeBonusAmount: 100,
	features: {
		isQuickPlayEnabled: true,
		isCmsEnabled: true,
		isFavoritesEnabled: true,
		isGroupByTournamentEnabled: true,
		media: {
			isLiveStreamEnabled: true,
			isLiveMatchTrackerEnabled: true,
		},
		isBetSlipShareEnabled: true,
		isTeamIconEnabled: true,
		bannerType: "cms",
		quickPlayOptions: [
			"bet-builder-picks",
			"most-played-events",
			"betting-tips",
		],
	},
	isMaintenanceEnabled: true,
	isReadyBetRetailEnabled: true,
	isTermsAndConditionsPdfEnabled: false,
};
